import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ShActionItemComponent } from '../action-item/action-item.component';
import { ActionGroup, ActionGroupStyle } from './entities/action-group.entity';

@Component({
    standalone: true,
    selector: 'sh-action-group',
    templateUrl: './action-group.component.html',
    styleUrls: ['./action-group.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ShActionItemComponent]
})
export class ShActionGroupComponent {
    public classNames = '';
    public groupItemClassNames = '';
    public _actionGroup: ActionGroup;

    @Input() bubbleEvent = true;
    @Input() childComponentClasses?: string[];
    @Input() inOverflownContainer = false;

    @Input() set actionGroup(group: ActionGroup) {
        if (!group) {
            return;
        }
        this.initActionGroup(group);
    }

    private initActionGroup(group: ActionGroup): void {
        this._actionGroup = group;
        this.setClassNames(group);
        this.setGroupItemClassNames(group);
    }

    private setClassNames(group: ActionGroup): void {
        this.classNames = [group.style ?? ActionGroupStyle.Default, ...(group.modifiers ?? [])].join(' ');
    }

    private setGroupItemClassNames(group: ActionGroup): void {
        this.groupItemClassNames = ['sh-action-group__item', ...(group.itemModifiers ?? [])].join(' ');
    }
}

export * from '../action-group/entities/action-group.entity';
